function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a1 1 0 001 1h1a1 1 0 100-2h-1a1 1 0 00-1 1m4 8h-2v-4a1 1 0 00-1-1H5a1 1 0 00-1 1v4H2V8h20v10zM6 22h12v-7H6v7zM6 6h12V2H6v4zm16 0h-2V1a1 1 0 00-1-1H5a1 1 0 00-1 1v5H2C.897 6 0 6.897 0 8v10c0 1.103.897 2 2 2h2v3a1 1 0 001 1h14a1 1 0 001-1v-3h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
});

var SvgIconPrint = function SvgIconPrint(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconPrint;